import { z } from 'zod';

const PaymentPlanDiscountSchema = z.object({
  baasPTID: z.string(),
  discountAmount: z.nullable(z.unknown()),
  discountDescription: z.string(),
  discountPercent: z.number(),
  discountPeriod: z.number(),
  groupDescription: z.string(),
  id: z.number(),
  maxAmount: z.nullable(z.unknown()),
});

export const PaymentPlanResponseSchema = z.object({
  baasPTGID: z.string(),
  currentPaymentPeriod: z.number(),
  description: z.string(),
  expirationDate: z.nullable(z.unknown()),
  free: z.boolean(),
  paymentPlanGroupId: z.number(),
  planDiscounts: z.array(PaymentPlanDiscountSchema),
  selectable: z.boolean(),
  sticky: z.boolean(),
});

// TODO add schema for getBalance

export type PaymentPlanResponse = z.infer<typeof PaymentPlanResponseSchema>;

export type PaymentPlanDiscount = z.infer<typeof PaymentPlanDiscountSchema>;
